import axios from "axios";
import { API_URL } from "../../services/api";

/**
 * It sends a POST request to an API endpoint with the data and the recaptcha token
 * @param data - is the form data
 * @param recaptcha - the value of the recaptcha
 * @param recaptchaInstance - is the recaptcha instance
 * @param slug - is the name of the form, it's used to identify the form in the database
 * @param setSending - a function that sets the state of sending to true or false
 * @returns An object with two properties: success and message.
 */
const sendMail = (data, recaptcha, recaptchaInstance, slug, setSending) => {
    if (recaptcha) {
        const contact = {
            ...data,
            slug_form: slug,
            recaptcha,
        };
        document.getElementById("loading").style.display = "flex";
        setSending(true);
        return axios
            .post(API_URL + "send-mail", contact)
            .then((response) => {
                return {
                    success: true,
                    message: response.data.message,
                };
            })
            .catch((error) => {
                console.log(error);
                return {
                    success: false,
                    message: error,
                };
            })
            .finally(() => {
                recaptchaInstance.execute();
                document.getElementById("loading").style.display = "none";
                setSending(false);
            });
    } else {
        return {
            success: false,
            message: "Capcha inválido",
        };
    }
};

export default sendMail;
